export default __webpack_public_path__ + "static/media/instagramWallRotterdam.c9cb37c8.png";